import React from 'react';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const EmptyList: React.FC = () => {
  return (
    <Box display="flex" justifyContent="center" p="24">
      <Text>You have not added any items</Text>
    </Box>
  );
};
